import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { TestReportApiRef } from './api/TestReportApi';
import { TestReportClient } from './api/TestReportClient';
import { rootRouteRef } from './routes';

export const TestReportPlugin = createPlugin({
  id: 'test-report',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: TestReportApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new TestReportClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const ReportPage = TestReportPlugin.provide(
  createRoutableExtension({
    name: 'UserPage',
    component: () => import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
